import { render, staticRenderFns } from "./topics-list-panel.vue?vue&type=template&id=a28e036c&scoped=true&"
import script from "./topics-list-panel.ts?vue&type=script&lang=ts&"
export * from "./topics-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./topics-list-panel.scss?vue&type=style&index=0&id=a28e036c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28e036c",
  null
  
)

export default component.exports